import React from 'react';

function Testimonials() {
  const reviews = [
    {
      text: '"กรีกโยเกิร์ตเนื้อนุ่มแน่นละมุนมาก ทานคู่กับครัวซองต์กรอบนอกนุ่มในคือที่สุด ผลไม้สดหวานฉ่ำ ประทับใจมากค่ะ"',
      name: 'คุณณิชาภัทร (บี)',
      role: 'ลูกค้าประจำ Line OA',
      initial: 'B'
    },
    {
      text: '"ชอบความคลีนและมินิมอลแบบกรีกสไตล์ โยเกิร์ตเข้มข้นสู้ฟัน กราโนล่าหอมน้ำผึ้งกรอบนาน และแพ็กเกจน่ารักมากครับ"',
      name: 'คุณณัฐพงษ์ (ตั้ม)',
      role: 'Verified Customer',
      initial: 'T'
    },
    {
      text: '"ร้านโปรดสำหรับมื้อเช้าวันพักผ่อน น้ำผึ้งป่าหอมหวานธรรมชาติ ครัวซองต์เนยแท้ฟินมาก ทานแล้วรู้สึกสดชื่นสุขภาพดีค่ะ"',
      name: 'คุณมลดา (แก้ม)',
      role: 'Healthy Lifestyle Enthusiast',
      initial: 'K'
    }
  ];

  return (
    <section className="py-20 lg:py-24 bg-white border-b border-brand-200/70 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 space-y-3">
          <div className="inline-flex items-center gap-2 text-brand-600">
            <span className="w-6 h-[1px] bg-brand-400"></span>
            <span className="text-[11px] uppercase tracking-[0.25em] font-bold">
              Feedback & Love
            </span>
            <span className="w-6 h-[1px] bg-brand-400"></span>
          </div>
          
          <h2 className="font-serif text-3xl sm:text-4xl font-normal text-brand-900 tracking-tight">
            Guest Reviews
          </h2>
          
          <p className="text-xs sm:text-sm text-brand-600/80 font-light">
            ความประทับใจจริงจากผู้ที่หลงรักกรีกโยเกิร์ตและครัวซองต์ของเรา
          </p>
        </div>

        {/* 3 Review Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-[#FAFCFE] p-8 rounded-3xl border border-brand-200/70 shadow-xs hover:shadow-lg transition-all duration-300 flex flex-col justify-between group"
            >
              <div>
                {/* Quotation mark in Greek Blue */}
                <div className="text-brand-400 mb-4 font-serif text-4xl leading-none select-none">
                  “
                </div>
                <p className="text-sm text-brand-800/90 font-light leading-relaxed">
                  {review.text}
                </p>
              </div>

              <div className="mt-8 pt-6 border-t border-brand-100 flex items-center space-x-3.5">
                <div className="w-10 h-10 rounded-full bg-brand-600 text-white flex items-center justify-center font-serif font-bold text-sm shadow-xs">
                  {review.initial}
                </div>
                <div>
                  <span className="text-xs font-semibold text-brand-900 block font-sans">
                    {review.name}
                  </span>
                  <span className="text-[10px] text-brand-500 uppercase tracking-wider">
                    {review.role}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Testimonials;
